import { Typography } from "@mui/material";
import React from "react";
import config from "config";

export interface BoardMember {
  name: string;
  title?: string;
}

function BoardMembers() {
  const boardMembers: Array<BoardMember> = config.trustees;
  return (
    <div style={{ marginLeft: "10%", marginTop: "50px" }}>
      <Typography variant="subtitle1">Current Board Members:</Typography>
      <ul>
        {boardMembers.map((member) => (
          <li>
            <Typography variant="body2">{`${member.name} ${
              member.title || ""
            }`}</Typography>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default BoardMembers;
